module.exports = __webpack_public_path__ + "static/media/homepage_atf_1.c2699a11.png";